import { Route, Routes } from "react-router-dom";
import Kalmainhome from "./components/KalHome/Kalmainhome";
import Maincontact from "./components/Contactus/Maincontact";
import Login from "./components/SIgnin/Login";
import Register from "./components/SIgnin/Register";
import Addtocart from "./components/Addtocart/Addtocart";
import Wishlist from "./components/Addtocart/Wishlist";
import TermsAndConditionsPage from "./components/Privacy/Termsandconditions";
import Privacypolicy from "./components/Privacy/Privacypolicy";
import Faq from "./components/Privacy/Faq";
import Trackyourorder from "./components/Trackyourorder/Trackyourorder";
import Descriptionpreview from "./components/Descriptionpreview/Descriptionpreview";
import CategoryProducts from "./components/ProductsNew/CategoryProducts";
import SeeAllSubcategory from "./components/ProductsNew/SeeAllSubcategory";
import BackToTop from "./components/BackToTop/BackToTop";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import GlobalAlert from "./components/GlobalAlert/GlobalAlert";
import AuthLayout from "./layouts/AuthLayout";
import HeadFootLay from "./layouts/HeadFootLay";
import FullLayout from "./layouts/FullLayout";
import NotFoundPage from "./components/NotFoundPage/NotFoundPage";

function App() {
  return (
    <>
      <GlobalAlert />
      <Routes>
      <Route element={<AuthLayout />}>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/register" element={<Register />} />
      </Route>
      <Route element={<FullLayout />}>
        <Route exact path="/" element={<Kalmainhome />} />
        <Route exact path="/:CategoryID" element={<CategoryProducts />} />
      </Route>
      <Route element={<HeadFootLay />}>
        <Route exact path="/MyProfile/Addtocart" element={<Addtocart />} />
        <Route exact path="/MyProfile/Wishlist" element={<Wishlist />} />
        <Route exact path="/contactus" element={<Maincontact />} />
        <Route path="/seeall/:subCategoryId" element={<SeeAllSubcategory />} />
        <Route path="/product/:ProductId" element={<Descriptionpreview />} />
        <Route exact path="/TrackYourOrder/myOrders" element={<Trackyourorder />} />
        <Route exact path="/Terms/Conditions" element={<TermsAndConditionsPage />} />
        <Route exact path="/Privacy/Policy" element={<Privacypolicy />} />
        <Route exact path="/Faq/faq" element={<Faq />} />
        <Route exact path="/myProfile" element={<ProfilePage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <BackToTop />
    </>
  );
}

export default App;
